import React, { useState } from 'react'
import { Row, Col } from "antd"
import { useMediaQuery } from "react-responsive"
import businessImg from "images/v2/person_globe.png"
import phoneImg from "images/v2/phone-v2.svg"

import mailImg from "images/v2/mail-v2.svg"
import BusinessForm from "../business_pages/components/BusinessForm"
import SuccessModal from "../business_pages/components/SuccessModal"

const SolutionSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [isFormModalVisible, setIsFormModalVisible] = useState(false)
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false)

  return (
    <>
      <Row
        // gutter={{ lg: 16 }}
        align="middle"
        style={{
          marginTop: isMobileScreen ? "0px" : "0px",
          paddingTop: "30px",
          padding: isMobileScreen ? "15px" : "",
          marginBottom: "-200px",
          background: "#2F2946",
          color: "#FFFFFF",
        }}
      >
        <Col span={24} order={2} md={{ order: 1, span: 12 }} xl={{ span: 9, offset: 4 }}>
          <img src={businessImg} className="solution-contacts-mail-icon" style={{width: "100%"}} />
        </Col>
        <Col span={24} order={1} md={{ order: 2, span: 12 }} xl={{ span: 11 }}>
          <div
            className="section-title about-title"
            style={{
              fontSize: "30px",
              letterSpacing: "1px",
              color: "#FFFFFF",
            }}
          >
            {"Turi ETSY parduotuvę?"}
          </div>
          <div
            className="section-title about-title"
            style={{
              fontSize: "20px",
              fontWeight: "400",
              letterSpacing: "1px",
              color: "#FFFFFF",
              fontFamily: "Trenda-regular",
            }}
          >
            {"Išbandyk Alsendo integraciją ir perkelk savo verslą į kitą lygį."}
          </div>
          <div className="section-buttons">
            <button
              className="btn btn-primary-alsendo btn-lg btn-circle"
              onClick={() => {
                setIsFormModalVisible(true)
              }}
            >
              {"Gauti pasiūlymą"}
            </button>
          </div>
          <div
            className="solution-contacts"
            style={{
              display: isMobileScreen ? "block" : "flex",
              marginTop: isMobileScreen ? "10px" : "25px"
            }}
          >
            <div
              className="solution-contacts-mail"
              style={{
                marginRight: "30px",
                width: isMobileScreen ? "100%" : "auto",
                display: "flex",
              }}
            >
              <img src={mailImg} style={{
                marginRight: "10px"
              }} />
              <div className="info-font nice-select">
                <a href="mailto: pardavimai@alsendo.lt" style={{color: "#FFF"}}>
                  {"pardavimai@alsendo.lt"}
                </a>
              </div>
            </div>
            <div
              className="solution-contacts-phone"
              style={{
                width: isMobileScreen ? "100%" : "auto",
                marginTop: isMobileScreen ? "15px" : "",
                display: "flex",
              }}
            >
              <img src={phoneImg}  style={{
                marginRight: "10px",
              }} />
              <div
                className="nice-select info-font"
              >
                <a href="tel:+37065828980" style={{
                  color: "#FFF"
                }}>
                  +37065828980
                </a>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {isFormModalVisible && (
        <BusinessForm
          setIsFormModalVisible={setIsFormModalVisible}
          setIsSuccessModalVisible={setIsSuccessModalVisible}
        />
      )}
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  )
}

export default SolutionSection
